import React, { ReactNode } from 'react';
import { Copy, Flex, Stack, SvgInfo } from '@grubhubprod/gh-cookbook-react';
import { Tooltip } from 'src/components/Tooltip/Tooltip';

export interface EmailInputLabelProps {
  disabled?: boolean;
  disabledInfo?: ReactNode;
}

export const EmailInputLabel: React.FC<EmailInputLabelProps> = ({
  disabled,
  disabledInfo,
}) => {
  const labelTextElement = 'Email *';

  if (!disabled || !disabledInfo) {
    return <>{labelTextElement}</>;
  }

  return (
    <Flex>
      <Stack x="xxx-sm">{labelTextElement}</Stack>

      <Tooltip
        maxWidth="290px"
        roundedContainer
        content={
          <Copy variant="body" color="invertedPrimaryText">
            {disabledInfo}
          </Copy>
        }
      >
        <Stack as="span">
          <Copy variant="body" color="secondaryText">
            <SvgInfo aria-label="tooltip disabled info" size="20px" />
          </Copy>
        </Stack>
      </Tooltip>
    </Flex>
  );
};
